import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <h2>Polityka Prywatności</h2>
      
      <div className="privacy-content">
        <p>
          Administratorem Twoich danych osobowych, które podajesz w powyższym formularzu, jest Grupa OLX Sp. z o.o. z siedzibą w Poznaniu. Podanie danych jest dobrowolne, jednakże niezbędne, abyśmy mogli się z Tobą kontaktować oraz abyś mógł otrzymywać informacje handlowe i marketingowe m. in. o usługach, promocjach i ofertach specjalnych Grupy OLX.
        </p>

        <p>
          Twoje dane będą przetwarzane w celu przedstawienia Ci oferty współpracy oraz umożliwienia dalszego kontaktu z Tobą, a także przesyłania informacji podsumowujących. W związku z powyższym przysługuje Ci prawo dostępu do Twoich danych, prawo do ich poprawiania, usunięcia, przenoszenia oraz do ograniczenia ich przetwarzania.
        </p>

        <p>
          Możesz również sprzeciwić się dalszemu przetwarzaniu Twoich danych – będzie to jednoznaczne z rezygnacją z dalszego przedstawiania Ci oferty współpracy oraz otrzymywania informacji marketingowych.
        </p>

        <p>
          Aby dowiedzieć się więcej o swoich prawach, zapoznaj się z naszą Polityką prywatności dostępną tutaj:
        </p>

        <p>
          OLX – <a href="https://pomoc.olx.pl/hc/pl/articles/360000901525-Polityka-Prywatno%C5%9Bci" target="_blank" rel="noopener noreferrer">https://pomoc.olx.pl/hc/pl/articles/360000901525-Polityka-Prywatno%C5%9Bci</a>
        </p>

        <p>
          W celu zapewnienia realizacji Twoich praw, skontaktuj się z nami za pomocą <a href="https://pomoc.olx.pl/hc/pl/requests/new?ticket_form_id=227685" target="_blank" rel="noopener noreferrer">Formularza Kontaktowego</a>. Masz również prawo do złożenia skargi do Prezesa Urzędu Ochrony Danych Osobowych: Stawki 2, 00-193 Warszawa.
        </p>

        <h3>Podstawa prawna i okres przetwarzania</h3>
        <p>
          Administrator przetwarza Twoje dane osobowe na podstawie art. 6 ust. 1 lit. f) Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 ("RODO"), tj. w związku ze swoim prawnie uzasadnionym interesem w celu przedstawienia Ci oferty współpracy oraz umożliwienia dalszego kontaktu z Tobą oraz przesyłania informacji handlowych i marketingowych m. in. o usługach, promocjach i ofertach specjalnych Grupy OLX.
        </p>

        <p>
          Podane w formularzu dane osobowe będą przetwarzane w celu określonym powyżej, nie dłużej jednak niż przez 12 miesięcy od dnia przesłania formularza.
        </p>

        <h3>Odbiorcy danych</h3>
        <p>
          Dostęp do Twoich danych otrzymają upoważnieni do tego pracownicy Administratora. W celach określonych wyżej Administrator może również powierzać przetwarzanie Twoich danych osobowych swoim usługodawcom, w tym w szczególności podmiotom świadczącym na rzecz Administratora usługi IT oraz usługi marketingowe. Odbiorcami Twoich danych mogą ponadto być uprawnione do tego organy (np. sądy, prokuratury, urzędy skarbowe). Twoje dane nie są natomiast przesyłane do państw trzecich (tj. do państw spoza Europejskiego Obszaru Gospodarczego), ani do organizacji międzynarodowych.
        </p>

        <div className="back-button">
          <Link to="/">Powrót do formularza</Link>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy; 